import { Row, Col } from "react-bootstrap";

export const GenericHeader = ({ headerData }) => {
  return (
    <Row
      style={{
        padding: "20px 60px",
        height: "82px",
        backgroundColor: "var(--bg-alt-2)",
      }}
      className="Page-row-padding"
    >
      <Row className="mb-4">
        {headerData.map((item, index) => (
          <Col md={2} key={item.label || `header-${index}`}>
            <div className="d-flex flex-column nowrap">
              <small>{item.label}</small>
              <strong>{item.value}</strong>
            </div>
          </Col>
        ))}
      </Row>
    </Row>
  );
};

